// Librerias
import React from 'react'
import { AutoSizer, Table, Column } from 'react-virtualized'
// Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
// Style
import classNames from 'classnames/bind'
import * as cssModal from './modal.css'
import * as cssTabla from './mantenedorLocal.css'
let cx = classNames.bind(cssModal)

// function as a children FTW! :D
export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = { visible: false }
        this.show  = ()=> this.setState({visible: true})
        this.hide  = ()=> this.setState({visible: false})
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}

export class ModalAgregarLocal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            local: {
                idCliente: this.props.idCliente,
                nombre: '',
                numero: '',
                idFormatoLocal: 4,
                idJornadaSugerida: 1,
                horaApertura: '00:00',
                horaCierre: '00:00',
                emailContacto: '',
                telefono1: '',
                telefono2: '',
                stock: 1,
                cutComuna: 13101,
                direccion: ''
            },
            error: {}
        }
        this.onInputChange = (key, evt)=>{
            let actualizado = {}
            actualizado[key] = evt.target.value
            this.setState({ local: Object.assign({}, this.state.local, actualizado)})
        }
        this.handleSubmit = (evt)=>{
            evt.preventDefault()
            evt.stopPropagation()
            this.setState({error: {}}, ()=>{
                this.props.agregarLocal(this.state.local)
                    .then(()=>
                        this.props.hideModal()
                    )
                    .catch(error=>{
                        this.setState({error: error.data})
                    })
            })
        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Nuevo Local</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="form-horizontal" action="" onSubmit={this.handleSubmit}>
                        {/* Numero */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Numero</label>
                            <div className="col-sm-5">
                                <input type="text" className="form-control" placeholder="CECO"
                                       value={this.state.local.numero} onChange={this.onInputChange.bind(this, 'numero')}
                                />
                                {this.state.error.numero && <span className={cx('form__error-message')}>{this.state.error.numero[0]}</span>}
                            </div>
                        </div>
                        {/* Nombre */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Nombre</label>
                            <div className="col-sm-5">
                                <input type="text" className="form-control" placeholder="Nombre de local"
                                       value={this.state.local.nombre} onChange={this.onInputChange.bind(this, 'nombre')}
                                />
                                {this.state.error.nombre && <span className={cx('form__error-message')}>{this.state.error.nombre[0]}</span>}
                            </div>
                        </div>
                        {/* Formato */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Formato</label>
                            <div className="col-sm-5">
                                <select className="form-control"
                                        value={this.state.local.idFormatoLocal}
                                        onChange={this.onInputChange.bind(this, 'idFormatoLocal')}
                                >
                                    {this.props.formatoLocales.map(formato=>
                                        <option key={formato.idFormatoLocal} value={formato.idFormatoLocal}>{formato.nombre}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                        {/* Jornada */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Jornada</label>
                            <div className="col-sm-5">
                                <select className="form-control"
                                        value={this.state.local.idJornadaSugerida}
                                        onChange={this.onInputChange.bind(this, 'idJornadaSugerida')}
                                >
                                    {this.props.jornadas.map(jornada=>
                                        <option key={jornada.idJornada} value={jornada.idJornada}>{jornada.nombre}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                        {/* Hora Apertura */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Hora Apertura</label>
                            <div className="col-sm-5">
                                <input type="time" className="form-control"
                                       value={this.state.local.horaApertura} onChange={this.onInputChange.bind(this, 'horaApertura')}
                                />
                                {this.state.error.horaApertura && <span className={cx('form__error-message')}>{this.state.error.horaApertura[0]}</span>}
                            </div>
                        </div>
                        {/* Hora Cierre */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Hora Cierre</label>
                            <div className="col-sm-5">
                                <input type="time" className="form-control"
                                       value={this.state.local.horaCierre} onChange={this.onInputChange.bind(this, 'horaCierre')}
                                />
                                {this.state.error.horaCierre && <span className={cx('form__error-message')}>{this.state.error.horaCierre[0]}</span>}
                            </div>
                        </div>
                        {/* Email */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Email</label>
                            <div className="col-sm-5">
                                <input type="text" className="form-control"
                                       value={this.state.local.emailContacto} onChange={this.onInputChange.bind(this, 'emailContacto')}
                                />
                                {this.state.error.emailContacto && <span className={cx('form__error-message')}>{this.state.error.emailContacto[0]}</span>}
                            </div>
                        </div>
                        {/* Telefono */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Telefonos</label>
                            <div className="col-sm-5">
                                <input type="text" className="form-control"
                                       value={this.state.local.telefono1} onChange={this.onInputChange.bind(this, 'telefono1')}
                                />
                                {this.state.error.telefono1 && <span className={cx('form__error-message')}>{this.state.error.telefono1[0]}</span>}
                            </div>
                            <div className="col-sm-5">
                                <input type="text" className="form-control"
                                       value={this.state.local.telefono2} onChange={this.onInputChange.bind(this, 'telefono2')}
                                />
                                {this.state.error.telefono2 && <span className={cx('form__error-message')}>{this.state.error.telefono2[0]}</span>}
                            </div>
                        </div>
                        {/* Stock */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Stock</label>
                            <div className="col-sm-5">
                                <input type="number" className="form-control"
                                       value={this.state.local.stock} onChange={this.onInputChange.bind(this, 'stock')}
                                />
                                {this.state.error.stock && <span className={cx('form__error-message')}>{this.state.error.stock[0]}</span>}
                            </div>
                        </div>
                        {/* Comuna */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Comuna</label>
                            <div className="col-sm-5">
                                <select className="form-control"
                                        value={this.state.local.cutComuna}
                                        onChange={this.onInputChange.bind(this, 'cutComuna')}
                                >
                                    {this.props.comunas.map(comuna=>
                                        <option key={comuna.cutComuna} value={comuna.cutComuna}>{comuna.nombre}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                        {/* Dirección */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Dirección</label>
                            <div className="col-sm-5">
                                <input type="text" className="form-control"
                                       value={this.state.local.direccion} onChange={this.onInputChange.bind(this, 'direccion')}
                                />
                                {this.state.error.direccion && <span className={cx('form__error-message')}>{this.state.error.direccion[0]}</span>}
                            </div>
                        </div>

                        <div className={cx('form-group', 'form__control-label')}>
                            <a className={cx("btn btn-block btn-default", 'btn-50-perc')} href="#" onClick={this.props.hideModal}>Cancelar</a>
                            <button className={cx("btn btn-block btn-primary", 'btn-50-perc')} type="submit">Agregar</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        )
    }
}

export class ModalEditarLocal extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            local: this.props.local,
            error: {}
        }
        this.onInputChange = (key, evt)=>{
            let actualizado = {}
            actualizado[key] = evt.target.type === 'checkbox'? evt.target.checked : evt.target.value
            this.setState({ local: Object.assign({}, this.state.local, actualizado)})
        }
        this.handleSubmit = (evt)=>{
            evt.preventDefault()
            evt.stopPropagation()
            this.setState({error: {}}, ()=>{
                this.props.actualizarLocal(this.state.local)
                    .then(()=>
                        this.props.hideModal()
                    )
                    .catch(error=>{
                        this.setState({error: error.data})
                    })
            })
        }
    }
    render(){
        return (
            <Modal show={true} onHide={this.props.hideModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Editando local: {this.props.local.cliente.nombreCorto} {this.props.local.numero}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="form-horizontal" action="" onSubmit={this.handleSubmit}>
                        {/* Nombre */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Nombre</label>
                            <div className="col-sm-5">
                                <input type="text" className="form-control" placeholder="Nombre de local"
                                       value={this.state.local.nombre} onChange={this.onInputChange.bind(this, 'nombre')}
                                />
                                {this.state.error.nombre && <span className={cx('form__error-message')}>{this.state.error.nombre[0]}</span>}
                            </div>
                        </div>
                        {/* Formato */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Formato</label>
                            <div className="col-sm-5">
                                <select className="form-control"
                                        value={this.state.local.idFormatoLocal}
                                        onChange={this.onInputChange.bind(this, 'idFormatoLocal')}
                                >
                                    {this.props.formatoLocales.map(formato=>
                                        <option key={formato.idFormatoLocal} value={formato.idFormatoLocal}>{formato.nombre}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                        {/* Jornada */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Jornada</label>
                            <div className="col-sm-5">
                                <select className="form-control"
                                        value={this.state.local.idJornadaSugerida}
                                        onChange={this.onInputChange.bind(this, 'idJornadaSugerida')}
                                >
                                    {this.props.jornadas.map(jornada=>
                                        <option key={jornada.idJornada} value={jornada.idJornada}>{jornada.nombre}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                        {/* Hora Apertura */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Hora Apertura</label>
                            <div className="col-sm-5">
                                <input type="time" className="form-control"
                                       value={this.state.local.horaApertura} onChange={this.onInputChange.bind(this, 'horaApertura')}
                                />
                                {this.state.error.horaApertura && <span className={cx('form__error-message')}>{this.state.error.horaApertura[0]}</span>}
                            </div>
                        </div>
                        {/* Hora Cierre */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Hora Cierre</label>
                            <div className="col-sm-5">
                                <input type="time" className="form-control"
                                       value={this.state.local.horaCierre} onChange={this.onInputChange.bind(this, 'horaCierre')}
                                />
                                {this.state.error.horaCierre && <span className={cx('form__error-message')}>{this.state.error.horaCierre[0]}</span>}
                            </div>
                        </div>
                        {/* Email */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Email</label>
                            <div className="col-sm-5">
                                <input type="text" className="form-control"
                                       value={this.state.local.emailContacto} onChange={this.onInputChange.bind(this, 'emailContacto')}
                                />
                                {this.state.error.emailContacto && <span className={cx('form__error-message')}>{this.state.error.emailContacto[0]}</span>}
                            </div>
                        </div>
                        {/* Telefono */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Telefonos</label>
                            <div className="col-sm-5">
                                <input type="text" className="form-control"
                                       value={this.state.local.telefono1} onChange={this.onInputChange.bind(this, 'telefono1')}
                                />
                                {this.state.error.telefono1 && <span className={cx('form__error-message')}>{this.state.error.telefono1[0]}</span>}
                            </div>
                            <div className="col-sm-5">
                                <input type="text" className="form-control"
                                       value={this.state.local.telefono2} onChange={this.onInputChange.bind(this, 'telefono2')}
                                />
                                {this.state.error.telefono2 && <span className={cx('form__error-message')}>{this.state.error.telefono2[0]}</span>}
                            </div>
                        </div>
                        {/* Stock */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Stock</label>
                            <div className="col-sm-5">
                                <input type="number" className="form-control"
                                       value={this.state.local.stock} onChange={this.onInputChange.bind(this, 'stock')}
                                />
                                {this.state.error.stock && <span className={cx('form__error-message')}>{this.state.error.stock[0]}</span>}
                            </div>
                        </div>
                        {/* Comuna */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Comuna</label>
                            <div className="col-sm-5">
                                <select className="form-control"
                                        value={this.state.local.cutComuna}
                                        onChange={this.onInputChange.bind(this, 'cutComuna')}
                                >
                                    {this.props.comunas.map(comuna=>
                                        <option key={comuna.cutComuna} value={comuna.cutComuna}>{comuna.nombre}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                        {/* Dirección */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Dirección</label>
                            <div className="col-sm-5">
                                <input type="text" className="form-control"
                                       value={this.state.local.direccion} onChange={this.onInputChange.bind(this, 'direccion')}
                                />
                                {this.state.error.direccion && <span className={cx('form__error-message')}>{this.state.error.direccion[0]}</span>}
                            </div>
                        </div>
                        {/* Cerrado */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">Restricción Egreso</label>
                            <div className="col-sm-5">
                                <input type="checkbox" className="form-control"
                                       checked={this.state.local.cerrado} onChange={this.onInputChange.bind(this, 'cerrado')}
                                />
                                {this.state.error.cerrado && <span className={cx('form__error-message')}>{this.state.error.cerrado[0]}</span>}
                            </div>
                        </div>
                        {/* Mall */}
                        <div className={cx('form-group', 'form__control-label')}>
                            <label className="col-sm-2 control-label">¿Es mall?</label>
                            <div className="col-sm-5">
                                <input type="checkbox" className="form-control"
                                       checked={this.state.local.mall} onChange={this.onInputChange.bind(this, 'mall')}
                                />
                                {this.state.error.mall && <span className={cx('form__error-message')}>{this.state.error.mall[0]}</span>}
                            </div>
                        </div>
                        {/* Tienda Web */}
                        <div className={cx('form-group', 'form__control-label')}>
                        <label className="col-sm-2 control-label">Tienda Web</label>
                            <div className="col-sm-5">
                                <input type="checkbox" className="form-control"
                                       checked={this.state.local.tiendaWeb} onChange={this.onInputChange.bind(this, 'tiendaWeb')}
                                />
                                {this.state.error.tiendaWeb && <span className={cx('form__error-message')}>{this.state.error.tiendaWeb[0]}</span>}
                            </div>
                        </div>

                        <div className={cx('form-group', 'form__control-label')}>
                            <a className={cx("btn btn-block btn-default", 'btn-50-perc')} href="#" onClick={this.props.hideModal}>Cancelar</a>
                            <button className={cx("btn btn-block btn-primary", 'btn-50-perc')} type="submit">Actualizar</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        )
    }
}

export class ModalPegarLocales extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            locales: [],
            todosValidos: false,
            errores: ''
        }
        this.onPaste = (evt)=>{
            evt.preventDefault()
            evt.clipboardData.items[0].getAsString(texto=>{
                const getTime = ((string='00:00')=>(
                    /^[0-9]{2}:[0-9]{2}:[0-9]{2}$/.test(string) ?
                        string.replace(/:[0-9]{2}$/, '')
                        :
                        ( /^[0-9]{2}:[0-9]{2}$/.test(string) ? string : '00:00' )
                ))
                let locales = texto.trim()
                    .split('\n')
                    .filter(row=>row!=='')
                    .map(row=> row.trim().split('\t'))
                    .map(row => {
                        return {
                            idCliente: this.props.idCliente,
                            numero:             row[0] || '',
                            nombre:             row[1] || '',
                            idJornadaSugerida:  row[2] || 3,
                            jornada:            this.props.jornadas.find(jor=>jor.idJornada==(row[2]||3)),
                            idFormatoLocal:     4,
                            horaApertura:       getTime(row[3]),
                            horaCierre:         getTime(row[4]),
                            emailContacto:      row[5] || '',
                            telefono1:          row[6] || '',
                            telefono2:          row[7] || '',
                            stock:              1,
                            cutComuna:          row[8] || 13101,
                            comuna:             this.props.comunas.find(com=>com.cutComuna==(row[8] || 7301)),
                            direccion:          row[9] || ''
                            }
                    })
                this.setState({
                    locales,
                    todosValidos: locales.filter(local=> (!local.jornada || !local.comuna) ).length==0 && locales.length>0,
                    errores: ''
                })
            })
        }

        this.agregarLocales = ()=>{
            this.setState({
                errores: ''
            },()=>{
                this.props.agregarLocales(this.state.locales)
                    .then(this.props.hideModal)
                    .catch(err=>{
                        this.setState({
                            errores: err.data.join('. ')
                        })
                    })
            })
        }
    }
    componentDidMount(){
        this.refInputPaste.focus()
    }
    render(){
        let {locales} = this.state
        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalPegarLocales')} >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <small className="col-md-8">Pegar las columnas: Ceco, Nombre, Jornada, Hora Apertura, Hora Cierre, Email, telefono1, telefono2, CUT Comuna y Direccion desde excel</small>
                        <input className="col-md-3" type="text" value='' onPaste={this.onPaste} ref={ref=>this.refInputPaste=ref}/>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className={cx('tabla-pegar-locales')}>
                    <AutoSizer>
                        {({height, width}) =>
                            <Table
                                    // general
                                    height={height}
                                    width={width}
                                    // headers
                                    headerHeight={30}
                                    headerClassName={cssTabla.headerColumn}
                                    // rows
                                    rowCount={locales.length}
                                    rowGetter={({index})=> locales[index]}
                                    rowHeight={40}
                                    rowClassName={({index})=> index<0? cssTabla.headerRow : ((index%2===0)? cssTabla.evenRow : cssTabla.oddRow)}
                                >
                                    {/* Cliente */}
                                    {/* Ceco */}
                                    <Column
                                        dataKey='numero' label="CECO"
                                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                                        width={40}
                                    />
                                    {/* Nombre */}
                                    <Column
                                        dataKey='nombre' label="Nombre"
                                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                                        width={120}
                                    />
                                    {/* Jornada */}
                                    <Column
                                        dataKey='idJornadaSugerida' label="Jornada"
                                        cellRenderer={({ dataKey, rowData }) =>
                                            rowData.jornada? rowData.jornada.nombre : <span className="label label-danger">INVALIDA</span>
                                        }
                                        width={70}
                                    />
                                    {/* Hora Apertura */}
                                    <Column
                                        dataKey='horaApertura' label="Apertura"
                                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                                        width={70}
                                    />
                                    {/* Hora Cierre */}
                                    <Column
                                        dataKey='horaCierre' label="Cierre"
                                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                                        width={50}
                                    />
                                    {/* Email */}
                                    <Column
                                        dataKey='emailContacto' label="Email"
                                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                                        width={100}
                                    />
                                    {/* Telefono 1 */}
                                    <Column
                                        dataKey='telefono1' label="Telefono1"
                                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                                        width={85}
                                    />
                                    {/* Telefono 2 */}
                                    <Column
                                        dataKey='telefono2' label="Telefono2"
                                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                                        width={85}
                                    />
                                    {/* Comuna */}
                                    <Column
                                        dataKey='cutComuna' label="CUT Comuna"
                                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) =>
                                            rowData.comuna? rowData.comuna.nombre : <span className="label label-danger">INVALIDA</span>
                                        }
                                        width={100}
                                    />
                                    {/* Direccion */}
                                    <Column
                                        dataKey='direccion' label="Dirección"
                                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                                        width={200}
                                        flexGrow={1}
                                    />
                                </Table>
                        }
                    </AutoSizer>
                </Modal.Body>
                <Modal.Footer>
                    <div className={"col-md-6 "+cssModal.textAlignLeft}>
                        <p>* JORNADA, corresponde a: (1) No definido, (2) Día, (3) Noche, (4) Día y Noche</p>
                        <p>* CUT COMUNA, corresponde a un el Código Unico Territorial. <a href="http://historico.ine.cl/canales/chile_estadistico/territorio/division_politico_administrativa/xls/240111/codigoterr.xls">ver códigos</a></p>
                    </div>
                    <div className="col-md-3">
                        {this.state.errores && (<div className="alert alert-danger">{this.state.errores}</div>)}
                    </div>
                    <div className="col-md-3 pull-right">
                        <button className="btn btn-md btn-default"
                                onClick={this.props.hideModal}
                        >Cancelar</button>
                        <button className="btn btn-md btn-primary"
                                disabled={this.state.todosValidos? '' : 'disabled'}
                                onClick={this.agregarLocales}
                        >Agregar</button>
                    </div>
                </Modal.Footer>
            </Modal>
        )
    }
}

export class ModalDireccion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            direccion: props.direccion || '',
            comuna: props.comuna || '',
            lat: null,
            lng: null,
            mostrarMapa: false,
            apiKey: null,
            mapsLoaded: false
        };
        this.mapaRef = null;
        this.map = null;
        this.marker = null;
    }

    componentDidMount() {
        this.obtenerApiKey();
    }

    obtenerApiKey() {
        fetch('/api/maps-key')
            .then(res => res.json())
            .then(data => {
                const apiKey = data.key;
                this.setState({ apiKey }, () => {
                    this.cargarGoogleMaps(apiKey);
                });
            })
            .catch(err => {
                console.error('Error cargando la API key:', err);
            });
    }

    cargarGoogleMaps(apiKey) {
        if (window.google && window.google.maps) {
            this.setState({ mapsLoaded: true });
            return;
        }

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
            this.setState({ mapsLoaded: true });
        };
        document.body.appendChild(script);
    }

    buscarDireccion = () => {
        const { direccion, comuna } = this.state;
        const fullAddress = `${direccion}, ${comuna}`;
        const geocoder = new window.google.maps.Geocoder();

        geocoder.geocode({ address: fullAddress }, (results, status) => {
            if (status === 'OK' && results[0]) {
                const location = results[0].geometry.location;
                this.setState({
                    lat: location.lat(),
                    lng: location.lng(),
                    mostrarMapa: true
                }, this.initMap);
            } else {
                alert('No se pudo encontrar la dirección.');
            }
        });
    };

    initMap = () => {
        if (!this.state.mapsLoaded || !this.mapaRef) return;

        const { lat, lng } = this.state;
        const center = { lat, lng };

        this.map = new window.google.maps.Map(this.mapaRef, {
            center,
            zoom: 15
        });

        this.marker = new window.google.maps.Marker({
            position: center,
            map: this.map,
            draggable: true
        });

        this.marker.addListener('dragend', (e) => {
            const pos = e.latLng;
            this.setState({
                lat: pos.lat(),
                lng: pos.lng()
            });
        });
    };

    handleGuardar = () => {
        const { lat, lng } = this.state;
        if (lat && lng) {
            this.props.onGuardar(this.props.id, lat, lng)
                .then(() => {
                    this.props.hideModal();
                })
                .catch(err => {
                    alert('Error al guardar la ubicación: ' + err.message);
                });
            //this.props.hideModal();
        }
    }

    render() {
        const { direccion, comuna, lat, lng, mostrarMapa } = this.state;

        return (
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalPegarLocales')}>
                <Modal.Header closeButton>
                    <Modal.Title>Editar Dirección</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group" style={{display: 'flex', items: 'center', justifyItems: 'center', gap: '8px'}}>
                        <label style={{margin: 'auto'}}>Dirección:</label>
                        <input
                            className="form-control"
                            style={{width: '50%'}}
                            type="text"
                            value={direccion}
                            onChange={(e) => this.setState({ direccion: e.target.value })}
                        />
                        <label style={{margin: 'auto'}}>Comuna:</label>
                        <input
                            className="form-control"
                            style={{width: '30%'}}
                            type="text"
                            value={comuna}
                            onChange={(e) => this.setState({ comuna: e.target.value })}
                        />
                    </div>
                    <button className="btn btn-primary" style={{margin: 'auto', display: 'flex'}} onClick={this.buscarDireccion}>
                        Buscar en mapa
                    </button>

                    {mostrarMapa && (
                        <div
                            ref={(ref) => (this.mapaRef = ref)}
                            style={{ width: '100%', height: '300px', marginTop: '10px' }}
                        />
                    )}
                </Modal.Body>

                <Modal.Footer>
                    {lat && lng && (
                        <div className="text-left pull-left">
                            <strong>Lat:</strong> {lat.toFixed(6)} | <strong>Lng:</strong> {lng.toFixed(6)}
                        </div>
                    )}
                    <button className="btn btn-default" onClick={this.props.hideModal}>
                        Cerrar
                    </button>
                    <button
                        className="btn btn-success"
                        onClick={this.handleGuardar}
                        disabled={!lat || !lng}
                    >
                        Guardar
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./frontEnd/admin/mantenedorLocales2/Modales.jsx